// extracted by mini-css-extract-plugin
module.exports = {"link":"pIhpc","upper":"EWtZb","lower":"s7jo7"};